import { AttackPattern, PatternState } from '../AttackPattern.js';

// The King copies the player's current weapon signature into a hostile mirror volley.
export class CorruptedCopy extends AttackPattern {
  constructor({ config, combat }) {
    super({ name: 'Corrupted Copy', telegraphDuration: 1.0, activeDuration: 0.5, minPhase: 1 });
    this.config = config;
    this.combat = combat;
  }

  onBegin(boss, player) {
    const weapon = this.combat?.weapons?.[boss.phase % Math.max(1, this.combat.weapons.length)];
    this._color = weapon?.config?.color ?? '#ff3b6b';
    this._origin = { x: player.x, y: player.y };
  }

  onActiveStart(boss, _player, pool) {
    const count = boss.phase >= 2 ? 10 : 8;
    const gap = Math.max(1, Math.floor(count / 3));
    for (let i = 0; i < count; i++) {
      if (i === gap || i === count - gap) continue;
      const a = (i / count) * Math.PI * 2;
      pool.fire({ x: this._origin.x, y: this._origin.y, vx: Math.cos(a) * this.config.speed, vy: Math.sin(a) * this.config.speed, radius: 2.5, damage: this.config.damage, color: this._color, lifetime: 3.5 });
    }
  }

  onEnd(boss) { boss.openVulnerability(0.6, 1.7); }

  getVisual() {
    if (this.state !== PatternState.TELEGRAPH) return null;
    return { kind: 'corruptedCopy', x: this._origin.x, y: this._origin.y, color: this._color };
  }
}
